import { FC } from 'react';

import { Route, useRoute } from '@core/navigation';
import { RoutePath } from '@common/constants';
import { Page, Header, Button } from '@wearehelpful/ui-kit';
import { useTranslation } from '@wearehelpful/ui-localization';

import { Index } from './Index/Index';
import { Details as Update } from './Details/Details';

export const Details: FC = () => {
  const { t } = useTranslation();
  const [, { push }] = useRoute();

  const handleOnContactHelpfulClick = () => {
    push({
      path: RoutePath.CONTACT_US,
    });
  };

  return (
    <Page>
      <Header>
        <Header.Back defaultHref={RoutePath.ROOT_MORE_INSURANCE} />
        <Header.Actions>
          <Button variant="secondary" onClick={handleOnContactHelpfulClick}>
            {t('actions.contactHelpful')}
          </Button>
        </Header.Actions>
      </Header>
      <Route path={RoutePath.INSURANCE_DETAILS} exact>
        <Index />
      </Route>
      <Route path={RoutePath.INSURANCE_DETAILS_DETAILS}>
        <Update />
      </Route>
    </Page>
  );
};
